module.exports = __webpack_public_path__ + "img/perfectiondetail_2.c096b79.webp";